import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Col, Row } from 'react-bootstrap';
import Button from '../../../../components/Button';
import Link from '../../../../components/Link';
import { formatPrice } from '../../../../utils/utils';

export type savedEstimatesTabProps = {
  savedEstimates?: any[];
};

const SavedEstimatesTab = ({ savedEstimates }: savedEstimatesTabProps) => {
  return (
    <Row className="p-0 py-3 m-0">
      {savedEstimates?.map((estimate, index) => (
        <Col
          key={index}
          className="border bg-white border-light-gray p-0 rounded-1 my-7 col-lg-5 mx-lg-5"
        >
          <div className="d-flex justify-content-between py-7 px-10 border-bottom">
            <span>{estimate.scenario1.name}</span>
            <span className="fw-light text-caption text-center text-light-grey-normal">
              {estimate.scenario1.dateOfSaving}
            </span>
          </div>
          <div className="py-7 px-10">
            <Row className="m-0 justify-content-end">
              <Col
                className={`${estimate.scenario2 ? 'col-5' : 'col-6'}`}
              ></Col>
              <Col className="p-0 d-flex justify-content-end">
                <span className="lh-xs px-lg-3">Scenario 1</span>
              </Col>
              {estimate.scenario2 && (
                <Col className="p-0 d-flex justify-content-end">
                  <span className="lh-xs px-lg-3">Scenario 2</span>
                </Col>
              )}
            </Row>
            <Row className="m-0">
              <Col
                className={`d-flex flex-column px-0 ${
                  estimate.scenario2 ? 'col-5' : 'col-6'
                }`}
              >
                <span className="text-caption fw-light striped-rows--odd py-1 py-2 px-3">
                  Stop Working at
                </span>
                <span className="text-caption fw-light striped-rows--odd py-1 py-2 px-3">
                  Begin Payment
                </span>
                <span className="text-caption fw-light striped-rows--odd py-1 py-2 px-3">
                  Total Monthly Amount
                </span>
              </Col>
              <Col className="d-flex flex-column p-0">
                <span className="text-caption striped-rows--odd text-end py-2 px-3">
                  {estimate.scenario1.whenToStopWorking}
                </span>
                <span className="text-caption striped-rows--odd text-end py-2 px-3">
                  {estimate.scenario1.whenToStartPension}
                </span>
                <span className="text-caption striped-rows--odd text-end py-2 px-3">
                  {formatPrice(estimate.scenario1.totalAmount)}
                </span>
              </Col>
              {estimate.scenario2 && (
                <Col className="d-flex flex-column px-0">
                  <span className="text-caption fw-normal striped-rows--odd py-2 px-3 text-end">
                    {estimate.scenario2.whenToStopWorking}
                  </span>
                  <span className="text-caption py-2 px-3 striped-rows--odd text-end">
                    {estimate.scenario2.whenToStartPension}
                  </span>
                  <span className="text-caption striped-rows--odd py-2 px-3 text-end">
                    {formatPrice(estimate.scenario2.totalAmount)}
                  </span>
                </Col>
              )}
            </Row>
          </div>
          <div className="pb-9 px-10 d-lg-flex justify-content-end">
            <Row className="m-0">
              <Link
                className="m-0"
                href={estimate.link}
                target={estimate.target}
              >
                <Button
                  variant="primary-outline"
                  leftIcon={light('file-pdf')}
                  size="sm"
                >
                  Download PDF
                </Button>
              </Link>
            </Row>
            <Row className="m-0 mt-5 m-lg-0 ms-lg-3">
              <Button
                variant="primary-outline"
                leftIcon={light('trash-can')}
                size="sm"
              >
                Delete Estimate
              </Button>
            </Row>
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default SavedEstimatesTab;
